"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeoutProperty = void 0;

var timeoutAfter = function timeoutAfter(timeMs) {
  var timeoutHandle = null;
  var promise = new Promise(function (resolve) {
    timeoutHandle = setTimeout(function () {
      resolve("Property timeout: exceeded limit of ".concat(timeMs, " milliseconds"));
    }, timeMs);
  });
  return {
    clear: function clear() {
      return clearTimeout(timeoutHandle);
    },
    promise: promise
  };
};

var TimeoutProperty = /*#__PURE__*/function () {
  function TimeoutProperty(property, timeMs) {
    _classCallCheck(this, TimeoutProperty);

    this.property = property;
    this.timeMs = timeMs;
  }

  _createClass(TimeoutProperty, [{
    key: "isAsync",
    value: function isAsync() {
      return true;
    }
  }, {
    key: "generate",
    value: function generate(mrng, runId) {
      return this.property.generate(mrng, runId);
    }
  }, {
    key: "shrink",
    value: function shrink(value) {
      return this.property.shrink(value);
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(v) {
        var t, propRun;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = timeoutAfter(this.timeMs);
                propRun = Promise.race([this.property.run(v), t.promise]);
                propRun.then(t.clear, t.clear);
                return _context.abrupt("return", propRun);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return TimeoutProperty;
}();

exports.TimeoutProperty = TimeoutProperty;